module.exports = __webpack_public_path__ + "img/ic_store_trait_top_img4.14a19392.png";